// package.json
var version = "0.41.0";

// src/version.ts
var compatibilityVersion = 10;
export {
  compatibilityVersion,
  version as npmVersion
};
